module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qmusc33-b256b6abe8e839ef1d95f5852f485193.jpg";